import FragmentSummary from "./fragment-summary";
import PatType from "../enums/pat-type";
import Kick from "./kick";
import FragmentDataType from "../enums/fragment-data-type";
import Ruleset from "../enums/ruleset";
import FootballState from "../state/football-state";

export default class PatKick extends Kick {
    constructor(kickedBy, kickedFrom) {
        super(kickedBy, kickedFrom);
        this.patType = PatType.KICK.code;

        // Add isDropKick to requiredData (after Kick's kickedBy and kickedFrom)
        this.requiredData.push({
            name: "isDropKick",
            type: FragmentDataType.Boolean,
            displayName: "Drop Kick",
            title: "Drop Kick",
            subtitle: "Was this PAT a drop kick?",
            defaultValue: false,
            isSkipped: () => this.ruleSetId !== Ruleset.IndoorFootball.code
        });
    }

    summarize(summaryContext, stringifier, play) {
        const isFaked =
            play?.getFirstFragment(FootballState.FieldGoalFakeRun) ||
            play?.getFirstFragment(FootballState.FieldGoalFakePass);
        let points;
        if (isFaked) {
            points = summaryContext?.gameConfig?.scoring?.runPAT;
        } else if (this.isDropKick) {
            points = summaryContext?.gameConfig?.scoring?.dropKickPAT;
        } else {
            points = summaryContext?.gameConfig?.scoring?.kickPAT;
        }
        const kickType = this.isDropKick ? "drop kick" : "kick";
        const message = `${stringifier.firstInitial(
            this.kickedBy
        )} ${points}-point ${kickType} attempt`;
        return new FragmentSummary(message);
    }

    getScoringPoints(gameConfig) {
        if (this.isDropKick) {
            return gameConfig.scoring.dropKickPAT;
        }
        return gameConfig.scoring.kickPAT;
    }

    excludeRequiredData(rd) {
        if (rd.isSkipped && rd.isSkipped()) {
            return true;
        }
        return false;
    }

    toJSON() {
        return {
            ...super.toJSON(),
            isDropKick: this.isDropKick
        };
    }
}
